import type {GenericAssignmentSessionAttrsT} from '@freckle/educator-entities/ts/common/models/generic-assignment-session'
import type {RlDomainT} from '@freckle/educator-entities/ts/common/models/rl-domain'
import type {RlStandardWithDomainT} from '@freckle/educator-entities/ts/common/models/rl-standard'
import type {RlStandardSetT} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import type {AssessmentAnswerT} from '@freckle/educator-entities/ts/math/assessment/models/assessment-answer'
import type {MathQuestionMapT} from '@freckle/educator-entities/ts/math/common/models/questions'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {AssessmentQuestionsReport} from '@freckle/school/ts/pages/assessment-report/components/assessment-questions-report'
import AssessmentSummary from '@freckle/school/ts/pages/assessment-report/components/assessment-summary'
import AssessmentTeacherReport from '@freckle/school/ts/pages/assessment-report/components/assessment-teacher-report'
import OverallResult from '@freckle/school/ts/pages/assessment-report/components/overall-result'

type Props = {
  assessmentSessions: Array<GenericAssignmentSessionAttrsT>
  assessmentAnswers: Array<AssessmentAnswerT>
  students: Array<StudentAttrs>
  questionMap: MathQuestionMapT
  teacher: BaseTeacherAttrs
  mathStandardSet: RlStandardSetT
  domains: Array<RlDomainT>
  standards: Array<RlStandardWithDomainT>
}

export default function AssessmentReport({
  assessmentSessions,
  assessmentAnswers,
  students,
  questionMap,
  mathStandardSet,
  domains,
  standards,
  teacher,
}: Props) {
  const {t} = useSafeTranslation()

  return (
    <>
      <H1>{t('ASSESSMENT_REPORT_TITLE')}</H1>

      <OverallResult assessmentAnswers={assessmentAnswers} questionMap={questionMap} />

      <AssessmentTeacherReport
        assessmentSessions={assessmentSessions}
        mathStandardSet={mathStandardSet}
        domains={domains}
        standards={standards}
        teacher={teacher}
      />

      <AssessmentSummary
        assessmentSessions={assessmentSessions}
        assessmentAnswers={assessmentAnswers}
        students={students}
        questionMap={questionMap}
      />

      <AssessmentQuestionsReport
        assessmentAnswers={assessmentAnswers}
        questionMap={questionMap}
        rlStandards={standards}
      />
    </>
  )
}
